import React from 'react';
import styles from './SGSMenuItem.module.scss';
import classnames from 'classnames';

type Props = {
    image: any;
    alt: string;
    active?: Boolean;
    className?: string;
};

const SGSMenuItem: React.FC<Props> = ({ image, alt, active = false, className, children }) => {
    return (
        <div className={classnames(styles.menuItemContainer, active && styles.menuItemActive, className)}>
            <div className={styles.menuItemBadge}>
                <div className={styles.menuItemOverlay}></div>
                <div className={styles.imageContainer}>
                    <img src={image} alt={alt} />
                </div>
            </div>
            <div>{children}</div>
            <div className={styles.underline}></div>
        </div>
    );
};

export default SGSMenuItem;
